import React from "react";
import { Header } from "..";
import "./faq.scss";

const PrivacyPolicy = () => {
  // const getLang = window.localStorage.getItem("lang");
  const getLang = "ar";
  return (
    <div className="main">
      <Header />
      <section className=" faqs-container">
        <div class="">
          <div className="text-white">
            <h1
              className={`text-center text-xl font-bold  ${
                getLang == "ar" ? "arabic-lang" : ""
              }`}
            >
              {getLang === "en" && "Frequently Asked Questions"}
              {getLang === "fr" && "Frequently Asked Questions"}
              {getLang === "ar" && "سياسة الخصوصية"}
            </h1>
            <div className="py-1 px-4 list-data">
              <p className={`mt-1  ${getLang === "ar" ? "arabic-lang" : ""}`}>
                {getLang === "en" &&
                  " You can subscribe to ' Swipe & Win' service by:"}
                {getLang === "fr" &&
                  "Vous pouvez souscrire au service 'Swipe & Win' en :"}
                {getLang === "ar" &&
                  `تجدون هنا أهم النقاط الرئيسية من سياسة الخصوصية الخاص بنا، وسيجري نشر جميع التعديلات على موقعنا. بوسعك الاطّلاع على أحدث إصدار من سياسة الخصوصيّة في أيّ وقت. وتُعتبر مواصلتك لاستخدام "الخدمة" أو "الموقع" بعد إجراء أي من هذه التعديلات موافقة منك على سياسة الخصوصيّة الجديدة.`}
              </p>
              <h6
                className={`font-bold  ${
                  getLang === "ar" ? "arabic-lang" : ""
                }`}
              >
                {getLang === "en" && "How I subscribe?"}
                {getLang === "fr" && "Comment m'abonner ?"}
                {getLang === "ar" && "نحتفظ بمعلوماتك الشخصية لعدة أسباب، اعتمادًا على كيفية تفاعلك مع خدماتنا، بما في ذلك:"}
              </h6>
              <p className={`mt-1  ${getLang === "ar" ? "arabic-lang" : ""}`}>
                {getLang === "en" &&
                  " You can subscribe to ' Swipe & Win' service by:"}
                {getLang === "fr" &&
                  "Vous pouvez souscrire au service 'Swipe & Win' en :"}
                {getLang === "ar" &&
                  `-تسهيل إنشاء الحساب والمصادقة عليه وإدارة حسابات المستخدمين:`}
              </p>
              <ul
                className={` list-inside	 list-disc pl-3  ${
                  getLang == "ar" ? "arabic-lang" : ""
                }`}
              >
                <li className=" mt-1">
                  {getLang === "en" && "Following the link via XXX app menu"}
                  {getLang === "fr" &&
                    "Suivre le lien via le menu de l'application XXX"}
                  {getLang === "ar" && "قد نحتفظ بمعلوماتك حتى تتمكن من إنشاء حسابك وتسجيل الدخول إليه، وكذلك الحفاظ على أمان حسابك."}
                </li>
                <li className=" mt-1">
                  {getLang === "en" && "Dial XXX from your mobile number"}
                  {getLang === "ar" &&
                    `تقديم وتسهيل تقديم الخدمات للمستخدم.`}
                  {getLang === "fr" &&
                    "Composez XXX depuis votre numéro de mobile"}
                </li>
                <li className=" mt-1">
                  {getLang === "en" &&
                    "Send SUB to XXX from your mobile number"}
                  {getLang === "fr" &&
                    "Envoyez SUB à XXX depuis votre numéro de mobile"}
                  {getLang === "ar" &&
                    `نقوم بالاحتفاظ بـمعلوماتك لتزويدك بالخدمة المطلوبة.`}
                </li>
              </ul>
              <p className={`mt-1  ${getLang === "ar" ? "arabic-lang" : ""}`}>
                {getLang === "en" &&
                  " You can subscribe to ' Swipe & Win' service by:"}
                {getLang === "fr" &&
                  "Vous pouvez souscrire au service 'Swipe & Win' en :"}
                {getLang === "ar" &&
                  `-الرد على استفسارات المستخدم / تقديم الدعم للمستخدمين:`}
              </p>
              <ul
                className={` pl-3 list-inside list-disc  ${
                  getLang == "ar" ? "arabic-lang" : ""
                }`}
              >
                <li className=" mt-1">
                  {getLang === "en" &&
                    "XXMB once upon scoring 10 or more correct questions"}
                  {getLang === "fr" &&
                    "XXMB une fois après avoir obtenu 10 bonnes questions ou plus"}
                  {getLang === "ar" &&
                    "نحتفظ بمعلوماتك للرد على استفساراتك وحل أي مشاكل محتملة قد تواجهك مع الخدمة المطلوبة."}
                </li>
                <li className=" mt-1">
                  {getLang === "en" && "XXX USD in Cash every day"}
                  {getLang === "fr" && "XXX USD en espèces chaque jour"}
                  {getLang === "ar" &&
                    "تنفيذ وإدارة طلباتك."}
                </li>
                <li className=" mt-1">
                  {getLang === "en" && "XXX USD in Cash every week"}
                  {getLang === "fr" && "XXX USD en espèces chaque semaine"}
                  {getLang === "ar" &&
                    "نقوم بالاحتفاظ بـالمعلومات الخاصة بك لتنفيذ وإدارة الطلبات والمدفوعات والمرتجعات والمبادلات التي تتم من خلال الخدمات."}
                </li>
              </ul>
              <p className={`mt-1  ${getLang === "ar" ? "arabic-lang" : ""}`}>
                {getLang === "en" &&
                  " You can subscribe to ' Swipe & Win' service by:"}
                {getLang === "fr" &&
                  "Vous pouvez souscrire au service 'Swipe & Win' en :"}
                {getLang === "ar" &&
                  `-حماية خدماتنا:`}
              </p>
              <ul
                className={` pl-3 list-inside list-disc  ${
                  getLang == "ar" ? "arabic-lang" : ""
                }`}
              >
                <li className=" mt-1">
                  {getLang === "en" &&
                    "XXMB once upon scoring 10 or more correct questions"}
                  {getLang === "fr" &&
                    "XXMB une fois après avoir obtenu 10 bonnes questions ou plus"}
                  {getLang === "ar" &&
                    "نحتفظ بمعلوماتك كجزء من جهودنا للحفاظ على خدماتنا آمنة، ونقوم بمراجعة تخزين معلوماتك لتوفير خدماتنا وتحسينها وإدارتها، "}
                </li>
                <li className=" mt-1">
                  {getLang === "en" && "XXX USD in Cash every day"}
                  {getLang === "fr" && "XXX USD en espèces chaque jour"}
                  {getLang === "ar" &&
                    "والتواصل معك، من أجل الحماية ومنع الاحتيال، والامتثال للقانون."}
                </li>
              </ul>
              <p className={`mt-1  ${getLang === "ar" ? "arabic-lang" : ""}`}>
                {getLang === "en" &&
                  " You can subscribe to ' Swipe & Win' service by:"}
                {getLang === "fr" &&
                  "Vous pouvez souscrire au service 'Swipe & Win' en :"}
                {getLang === "ar" &&
                  `-المعلومات الشخصية:`}
              </p>
              <ul
                className={` pl-3 list-inside list-disc  ${
                  getLang == "ar" ? "arabic-lang" : ""
                }`}
              >
                <li className=" mt-1">
                  {getLang === "en" &&
                    "XXMB once upon scoring 10 or more correct questions"}
                  {getLang === "fr" &&
                    "XXMB une fois après avoir obtenu 10 bonnes questions ou plus"}
                  {getLang === "ar" &&
                    "تعتمد على سياق تفاعلاتك معنا والخدمات، والاختيارات التي تقوم بها، والميزات التي تستخدمها. قد تتضمن المعلومات الشخصية التي "}
                </li>
                <li className=" mt-1">
                  {getLang === "en" && "XXX USD in Cash every day"}
                  {getLang === "fr" && "XXX USD en espèces chaque jour"}
                  {getLang === "ar" &&
                    "نجمعها ما يلي: أرقام الهواتف."}
                </li>
              </ul>
              <h6
                className={`font-bold  ${
                  getLang === "ar" ? "arabic-lang" : ""
                }`}
              >
                {getLang === "en" && "How I subscribe?"}
                {getLang === "fr" && "Comment m'abonner ?"}
                {getLang === "ar" && "هل نتلق أي معلومات من أطراف ثالثة؟"}
              </h6>
              <ul
                className={` pl-3 list-inside list-disc  ${
                  getLang == "ar" ? "arabic-lang" : ""
                }`}
              >
                <li className=" mt-1">
                  {getLang === "en" &&
                    "XXMB once upon scoring 10 or more correct questions"}
                  {getLang === "fr" &&
                    "XXMB une fois après avoir obtenu 10 bonnes questions ou plus"}
                  {getLang === "ar" &&
                    "نحن لا نتلقى أي معلومات من أطراف ثالثة. "}
                </li>
                <li className=" mt-1">
                  {getLang === "en" && "XXX USD in Cash every day"}
                  {getLang === "fr" && "XXX USD en espèces chaque jour"}
                  {getLang === "ar" &&
                    "سيتم حفظ معلوماتك الشخصية وعندما لا تكون هناك حاجة للاحتفاظ بها سنقوم إما بحذفها أو إخفاء هوية المعلومات."}
                </li>
              </ul>
              <h6
                className={`font-bold  ${
                  getLang === "ar" ? "arabic-lang" : ""
                }`}
              >
                {getLang === "en" && "How I subscribe?"}
                {getLang === "fr" && "Comment m'abonner ?"}
                {getLang === "ar" && "معلومات الحساب:"}
              </h6>
              <p className={`mt-1  ${getLang === "ar" ? "arabic-lang" : ""}`}>
                {getLang === "en" &&
                  " You can subscribe to ' Swipe & Win' service by:"}
                {getLang === "fr" &&
                  "Vous pouvez souscrire au service 'Swipe & Win' en :"}
                {getLang === "ar" &&
                  `إذا كنت ترغب في أي وقت في مراجعة أو تغيير الباقة الموجودة في حسابك أو إنهاء حسابك، فيمكنك:`}
              </p>
              <ul
                className={` pl-3 list-inside list-disc  ${
                  getLang == "ar" ? "arabic-lang" : ""
                }`}
              >
                <li className=" mt-1">
                  {getLang === "en" &&
                    "XXMB once upon scoring 10 or more correct questions"}
                  {getLang === "fr" &&
                    "XXMB une fois après avoir obtenu 10 bonnes questions ou plus"}
                  {getLang === "ar" &&
                    "الدخول إلى حسابك وقم بتحديث الباقة الخاص بك او إلغاء الاشتراك. "}
                </li>
                <li className=" mt-1">
                  {getLang === "en" && "XXX USD in Cash every day"}
                  {getLang === "fr" && "XXX USD en espèces chaque jour"}
                  {getLang === "ar" &&
                    "بناءً على طلبك لإنهاء حسابك، سنقوم بإلغاء تنشيط أو حذف حسابك ومعلوماتك من قواعد البيانات النشطة لدينا. ومع ذلك، قد نحتفظ "}
                </li>
                <li className=" mt-1">
                  {getLang === "en" && "XXX USD in Cash every day"}
                  {getLang === "fr" && "XXX USD en espèces chaque jour"}
                  {getLang === "ar" &&
                    "ببعض المعلومات في ملفاتنا لمنع الاحتيال واستكشاف المشكلات وإصلاحها والمساعدة في أي تحقيقات وفرض شروطنا القانونية  "}
                </li>
              </ul>
              <p className={`mt-1  ${getLang === "ar" ? "arabic-lang" : ""}`}>
                {getLang === "en" &&
                  " You can subscribe to ' Swipe & Win' service by:"}
                {getLang === "fr" &&
                  "Vous pouvez souscrire au service 'Swipe & Win' en :"}
                {getLang === "ar" &&
                  `والامتثال للمتطلبات القانونية المعمول بها.`}
              </p>
              <p className={`mt-1  ${getLang === "ar" ? "arabic-lang" : ""}`}>
                {getLang === "en" &&
                  " You can subscribe to ' Swipe & Win' service by:"}
                {getLang === "fr" &&
                  "Vous pouvez souscrire au service 'Swipe & Win' en :"}
                {getLang === "ar" &&
                  `إذا كان لا يزال لديك أي أسئلة أو استفسارات، يرجى التواصل مع grievance@blackngreen.com`}
              </p>
             
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};
export default PrivacyPolicy;
